<template>
	<div>
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 viewBox="0 0 80 80.8" style="enable-background:new 0 0 80 80.8;" xml:space="preserve">
			<g>
	<g>

			<rect x="34.9" y="-9.6" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -16.9026 40.0486)" class="st0" width="10" height="100"/>
	</g>
</g>
			<g>
	<g>

			<rect x="-10.1" y="35.4" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -16.9026 40.0486)" class="st0" width="100" height="10"/>
	</g>
</g>
</svg>
	</div>
</template>

<script>
	export default {
		name: "IconClose"
	}
</script>

<style scoped>
	.st0 {
		fill: #C4C090;
	}
</style>